import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { ExpandCircleDownOutlined } from '@mui/icons-material'

import Table from 'components/Table'

import PublishedCell from './PublishedCell'

import { longMonthYear, removeScriptTags } from 'helpers/formatters'
import Resource, { ValidResourceTypes } from 'types/Resource'
import { screenSize } from 'styles/shared'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Resource
}

type Props = {
  resource: Resource
  type: ValidResourceTypes
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const ThermostatReleaseRow = ({ resource, type, onSuccessfulSubmission, onClickEditResource }: Props) => {
  const [isCaretCollapsed, setIsCaretCollapsed] = useState(true)

  if (resource == null) {
    return <></>
  }

  return (
    <S.TableRow key={resource.name}>
      <S.VersionCell>
        {resource.version}
      </S.VersionCell>
      <S.ModelCell>
        {resource.models && resource.models.join(', ')}
      </S.ModelCell>
      <S.DescriptionCell>
        <S.CaretIcon
          onClick={() => setIsCaretCollapsed(!isCaretCollapsed)}
          aria-label={`${isCaretCollapsed ? 'Collapse' : 'Expand'}`}
          isCaretCollapsed={isCaretCollapsed}
        />
        <S.Description isCaretCollapsed={isCaretCollapsed}
          dangerouslySetInnerHTML={{ __html: removeScriptTags(resource.description) }}
        />
      </S.DescriptionCell>
      <S.DateCell>
        {resource.releaseDate && longMonthYear(resource.releaseDate)}
      </S.DateCell>

      <S.PublishedCell type={type} resource={resource} onSuccessfulSubmission={onSuccessfulSubmission} onClickEditResource={onClickEditResource} />
    </S.TableRow>
  )
}
export default ThermostatReleaseRow

const cellStyle = css`
  padding: 15px;
  min-width: 120px;

  align-items: flex-start;

  @media ${screenSize.medium} {
    font-size: 12px;
  }

  @media ${screenSize.small} {
    padding: 8px 15px;
  }
`

const S = {
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: flex-start;
    flex-basis: 50%;
  `,
  Description: styled.div.withConfig({
    shouldForwardProp: (prop) => !['isCaretCollapsed'].includes(prop)
  }) <{ isCaretCollapsed: boolean }>`
    overflow: hidden;
    text-overflow: ${({ isCaretCollapsed }) => (isCaretCollapsed ? 'ellipsis' : 'unset')};
    width: 600px;
    margin-right: 10px;
    white-space: ${({ isCaretCollapsed }) => (isCaretCollapsed ? 'nowrap' : 'normal')};
    height: ${({ isCaretCollapsed }) => (isCaretCollapsed ? '20px' : 'auto')};

    @media ${screenSize.mediumOnly} {
      width: 25vw;
    }
  `,
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 20%;
  `,
  VersionCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 15%;
    padding-left: 25px;

    @media ${screenSize.medium} {
      padding-left: 2rem;
    }
  `,
  ModelCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 15%;
  `,
  PublishedCell: styled(PublishedCell)`
    ${cellStyle}
    flex-basis: 20%;
  `,
  TableRow: styled(Table.Row)`
    padding-top: 10px;
    align-items: flex-start;

    @media ${screenSize.small} {
      align-items: unset;
    }
  `,
  CaretIcon: styled(ExpandCircleDownOutlined).withConfig({
    shouldForwardProp: (prop) => !['isCaretCollapsed'].includes(prop)
  }) <{ isCaretCollapsed: boolean }>`
    margin-right: 10px;
    transform: ${({ isCaretCollapsed }) => (isCaretCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)')};
  `
}
